<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="12" lg="12">
      <el-simple-table :items="dataList" />
    </v-col>
  </v-row>
</template>

<script>
import Enums from '@/enums'

export default {
  name: 'DataProvider',
  components: {},
  props: {
    mandateData: [Array, Object],
  },
  computed: {
    dataList() {
      return [
        {
          title: 'Identifikavimo kodas',
          value: this.mandateData.mandate_code,
        },
        {
          title: 'Įregistravimo data',
          value: this.mandateData.registration_date,
        },
        {
          title: 'Prokūros rūšis',
          value: Enums.procurationKind.lt[this.mandateData.procuracy_type],
        },
        {
          title: 'Sudarymo data',
          value: this.mandateData.formation_date,
        },
        {
          title: 'Prokūra ribota',
          value: this.mandateData.procuracy_restricted ? 'Prokūra ribota' : false,
          hide: !this.mandateData.procuracy_restricted,
        },
        {
          title: 'Data apibrėžtas terminas',
          value: this.mandateData.term_date,
          hide: !this.mandateData.term_date,
        },
      ]
    },
  },
}
</script>

<style>
</style>
